import { GlToastMixin } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Vue from '../../lib/utils/vue3compat/vue.js?vue3';

const instance = new Vue({ name: 'GlobalToastRoot', mixins: [GlToastMixin], render: () => null });

export default function showGlobalToast(...args) {
  return instance.$toast.show(...args);
}
